import { render, staticRenderFns } from "./SelectPlaceWithoutHall.vue?vue&type=template&id=98966dae&"
import script from "./SelectPlaceWithoutHall.vue?vue&type=script&lang=js&"
export * from "./SelectPlaceWithoutHall.vue?vue&type=script&lang=js&"
import style0 from "./SelectPlaceWithoutHall.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports